module.exports = __webpack_public_path__ + "static/media/padding-entry-bottom.3c7bb945.svg";